import {Component, OnDestroy, OnInit} from '@angular/core';
import {RatesSroMaster} from '../../shared/common-components/common-structure';
import {AlertService} from '../../services/alert/alert.service';
import {FrtRateEditService} from '../../services/frt-rate-edit/frt-rate-edit.service';
import {LoadingService} from '../../services/loading/loading.service';
import {ISubscription} from 'rxjs-compat/Subscription';
import {UserService} from '../../services/user/user.service';
import {User} from '../../services/user/user';
import {HhgCarrierRateFilingService} from '../hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import {ControlType} from '../hhg-rate-duns/control-type';
import {CarrierService} from '../../services/carrier/carrier.service';
import {DownloadFileResponse} from '../../shared/common-components/file-storage/downloadFileResponse';
import * as FileSaver from 'file-saver';
import AppConstants, {frt_download_template_success} from '../../shared/common-components/AppConstants';
import {takeWhile} from 'rxjs';
import {BehaviorSubject} from 'rxjs';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  UntypedFormBuilder,
  ReactiveFormsModule
} from '@angular/forms';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-frt-template-download',
    templateUrl: './frt-template-download.component.html',
    styleUrls: ['./frt-template-download.component.css'],
    imports: [ReactiveFormsModule, NgFor, NgIf]
})
export class FrtTemplateDownloadComponent implements OnInit, OnDestroy {
  sroId: Number = 0;
  sroIdList: RatesSroMaster[] = [];
  tmssloader: any;
  currentUser: User | any;
  carrierId: any;
  observer$ = new BehaviorSubject(true);
  ratesBidcyclesId;
  sroTypeClass: string;
  vehicleClassList: any[];
  ofmSro: boolean;
  frtTemplateForm: UntypedFormGroup;
  rateTypeId : Number = 0;
  vehicleClassSel: any;

  constructor(
      private frtRateEditService: FrtRateEditService,
      private loader: LoadingService,
      private alertService: AlertService,
      private userService: UserService,
      private hhgService: HhgCarrierRateFilingService,
      private hhgrateService: HhgCarrierRateFilingService,
      private carrierService: CarrierService,
      private fb: UntypedFormBuilder
  ) {
    this.tmssloader = this.loader;
  }

  /**
   * @description gets the user observable, based on it, getting the carrierId and control Id.
   */
  ngOnInit() {
    this.tmssloader = this.loader;
    this.tmssloader.show();
    this.initializeForm();
    this.hhgService.getCarrierIdByUser()
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(carrierId => {
        this.carrierId = carrierId;
        this.carrierService.getRateBidCycleId()
          .pipe(takeWhile(() => this.observer$.value))
          .subscribe((res: any) => {
            this.ratesBidcyclesId = res.ratesBidcyclesId;
            this.hhgrateService.getFrtCarryOverSros(this.ratesBidcyclesId, this.carrierId)
              .pipe(takeWhile(() => this.observer$.value))
              .subscribe((res1: any) => {
                this.tmssloader.hide();
                this.sroIdList = res1 as RatesSroMaster[];

                for (let i = 0; i < this.sroIdList.length; i++) {
                  if (this.sroIdList[i].rateTypesSroEntity[0].rateTypeId === 20 || this.sroIdList[i].rateTypesSroEntity[0].rateTypeId === 21
                    || this.sroIdList[i].rateTypesSroEntity[0].rateTypeId === 22 || this.sroIdList[i].rateTypesSroEntity[0].rateTypeId === 23
                    || this.sroIdList[i].rateTypesSroEntity[0].rateTypeId === 24 ||this.sroIdList[i].rateTypesSroEntity[0].rateTypeId === 25) {
                  this.ofmSro = true;
                  this.populateVehicleClass();
                  break;
                  } else {
                    this.ofmSro = false;
                  }
                }

              }, error => {
                this.tmssloader.hide();
                this.alertService.error('Unable to load Sro Types value. Please try again later or contact system administrator');
              });
          }, error => {
            this.tmssloader.hide();
            this.alertService.error('Unable to load rates bidcycles id  value. Please try again later or contact system administrator');
          });
      }, error => {
        this.tmssloader.hide();
        this.alertService.error('Unable to load TSP info values. Please try again later or contact system administrator');
      });
  }

  /**
   * @description initializes form group with controls
   */
  initializeForm() {
    this.frtTemplateForm = this.fb.group({
      sroId: new UntypedFormControl('', Validators.required),
      vehicleClass: new UntypedFormControl('', Validators.required)
    });
  }
  /** sroType: "Fleet Line Vehicles Dom"
   * @description gets the frt template file to download. Downloads the file using saveAs in FileSaver library.
   */
  getFrtFile() {
    const formValue = this.frtTemplateForm.value;
    if (AppConstants.isNotNullCondition(this.sroId)) {
      for (let i = 0; i < this.sroIdList.length; i++) {
        if ((this.sroIdList[i].sroType === 'Fleet Line Vehicles Dom') && (formValue.sroId == this.sroIdList[i].sroMasterId)) {
          switch (this.vehicleClassSel) {
            case 'Class 1':
              this.rateTypeId = 20;
              break;
            case 'Class 2':
              this.rateTypeId = 21;
              break;
            case 'Class 3':
              this.rateTypeId = 22;
              break;
          }
        } else if ((this.sroIdList[i].sroType === 'Fleet Line Vehicles Intl') && (formValue.sroId == this.sroIdList[i].sroMasterId)) {
            switch (this.vehicleClassSel) {
              case 'Class 1':
                this.rateTypeId = 23;
                break;
              case 'Class 2':
                this.rateTypeId = 24;
                break;
              case 'Class 3':
                this.rateTypeId = 25;
                break;
            }
          //this.rateTypeId = this.sroIdList[i].rateTypesSroEntity[0].rateTypeId;
         } else if ((this.sroIdList[i].sroType === 'Alternating' || this.sroIdList[i].sroType === 'Emergency' || this.sroIdList[i].sroType === 'General') && (formValue.sroId == this.sroIdList[i].sroMasterId)) {
          this.rateTypeId = this.sroIdList[i].rateTypesSroEntity[0].rateTypeId;
          break;
         }
      }
      this.tmssloader.show();
      let frtrRatesResult: DownloadFileResponse;
      this.frtRateEditService.getFrtTemplateFile(this.rateTypeId, this.sroId, this.carrierId, this.ratesBidcyclesId).subscribe(res => {
        console.log(res);
        frtrRatesResult = res as DownloadFileResponse;
        const byteData: number[] = frtrRatesResult.byteData;
        const fileName: string = frtrRatesResult.fileName;
        const numRows: number = frtrRatesResult.numberOfExcelRows;
        const bytes = new Uint8Array(byteData);
        const blob = new Blob([bytes], {
          type: null
        });
        console.log(numRows);
        FileSaver.saveAs(blob, fileName);
        this.alertService.success(frt_download_template_success);
        this.tmssloader.hide();
      }, error => {
        this.tmssloader.hide();
        this.alertService.error('Error while getting the template.');
      });
    } else {
      this.alertService.info('please make sure all options are selected, if issue persists please FRT Rate Filing menu');
    }
  }

  populateVehicleClass(){
    this.vehicleClassList = new Array();
    this.vehicleClassList = [{"Text" :"Class 1" , "Value" : "Class 1"},
                             {"Text" :"Class 2" , "Value" : "Class 2"},
                             {"Text" :"Class 3" , "Value" : "Class 3"}];
  }

  vehicleClassChange(vehicleClass : any){
    this.vehicleClassSel = vehicleClass;
  }

  /**
   * @description unsibscribes to the user subscription.
   */
  ngOnDestroy() {
  }

}